module.exports = __webpack_public_path__ + "static/Telemedicine- Covid 19-2501bf7011fd60ccebadaddaf1d9acc8.png";